
// eslint-disable-next-line import/prefer-default-export
export const HEIGHTS = {
    loading: 60,
    padding: 20,
    title: 23,
    empty: 26,
    hr: 1,
    splice: 75,
    odfport: ({ data: { fiber, port } }) => {
        const fiberIsLong = fiber?.container?.fiber_count?.name.length > 2
            && fiber?.sequence_number.toString().length >= 2;

        const portIsLong = (port?.container?.oss_switch_name && port.container.oss_switch_name.toString().length > 5)
        || port?.sequence.toString().length > 1;

        if (fiberIsLong && portIsLong) {
            return 112;
        }

        if (fiberIsLong || portIsLong) {
            return 92;
        }
        
        return 72;
    },
    switchport: ({ data: { port }, data }) => {
        if (port) {
            return 31;
        }
        return 26;
    },
    dataport: ({ data }) => {
        let height = 49;
        if (data.sfp) {
            data.sfp.optical_switch_ports.forEach((port) => {
                if (port.port) {
                    height += 37;
                } else {
                    height += 23;
                }
            });
        }
        return height;
    },
    sfp: 31,
    cable: 26,
    freeFiber: 23,
    damagedFiber: 26,
    document: 26,
    attributes: {
        numberingScheme: 46,
        uSlotNumber: 26,
    },
};
